import PropTypes from "prop-types";
import classNames from "classnames";
import ResponsiveNav from "../GlobalHeader/components/ResponsiveNav/component";
import ImageWrapper from "../ImageWrapper/component";
import LinkWrap from "../LinkWrap/component";
import { PageHeading } from "../Heading/component";
import { normalizeClass } from "../../utils/path/library";
import {
    BANNER_IMAGE_ASPECT_RATIO,
    BANNER_DERIVATIVE_WIDTHS,
} from "./constants";

/**
 * The PageIntro component.
 *
 * This component renders the show Intro section, with the host info, navigation and sharing tools
 *
 * @param {Object} props The component props
 * @returns {React.Component} Returns the Pageintro component
 */
export function PageIntro({
    showName = "",
    hostName = "",
    imageUrl = "",
    navigation = [],
    path = "",
    baseSection = "",
    subSection = "",
    hasMenu = true,
    showImage = true,
    noHeading = true,
    imageLink,
    description,
}) {
    const hostNameDisplay = hostName.trim() ? `with ${hostName.trim()}` : "";
    let introNavigation = null;
    if (navigation.length && hasMenu) {
        const navProps = {
            collapseOnMobile: false,
            items: navigation,
            path: path,
            className: "introNav",
            id: "page-intro-nav",
        };
        introNavigation = <ResponsiveNav {...navProps} />;
    }

    let cssShowName = "";
    if (showName) {
        cssShowName = normalizeClass("show", showName);
    }

    let cssSectionWithBanner = `introNav-${baseSection}-${subSection}`;

    const pageIntroClasses = classNames(
        "pageIntro",
        cssShowName,
        cssSectionWithBanner
    );

    const pageHeading = !noHeading ? (
        <PageHeading hidden={true} text={`${showName} ${hostNameDisplay}`} />
    ) : null;

    return (
        <div className={pageIntroClasses} data-testid="pageIntro">
            {pageHeading}
            {displayImage({ showImage, imageUrl, imageLink })}
            {introNavigation
                ? introNavigation
                : displayDescription(description)}
        </div>
    );
}

/**
 * Render an image, if it is available
 * @param {object} props The properties of PageIntro
 * @returns {object} JSX for the Image component
 */
function displayImage(props) {
    if (props.showImage === false) {
        return null;
    }

    const imageProps = {
        url: props.imageUrl,
        derivativeWidths: BANNER_DERIVATIVE_WIDTHS,
        sizesRatio: BANNER_IMAGE_ASPECT_RATIO,
        loading: null,
        type: "host-image",
        useoriginalimage: false,
        isAboveFold: true,
    };

    let image = null;
    if (props.imageUrl) {
        image = <ImageWrapper {...imageProps} />;
    }
    if (props.imageLink) {
        return <LinkWrap url={props.imageLink}>{image}</LinkWrap>;
    }

    return image;
}

function displayDescription(description) {
    if (description) {
        return <div className="description">{description}</div>;
    }
}

PageIntro.propTypes = {
    showName: PropTypes.string,
    hostName: PropTypes.string,
    imageUrl: PropTypes.string,
    navigation: PropTypes.array,
    path: PropTypes.string,
    baseSection: PropTypes.string,
    subSection: PropTypes.string,
    hasMenu: PropTypes.bool,
    showImage: PropTypes.bool,
    noHeading: PropTypes.bool,
};

export default PageIntro;
